import { render, staticRenderFns } from "./inactiveAccount.vue?vue&type=template&id=ae6176cc&"
import script from "./inactiveAccount.vue?vue&type=script&lang=js&"
export * from "./inactiveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports